module.exports = __webpack_public_path__ + "static/about_graphics_resized-712533914646a9bbbadc324a95d2c887.png";